import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { reduxForm } from "redux-form";
import LocaleStrings from "Languages";
import { BaseComponent } from "BaseComponent";
import { STRIPE_PUBLISHABLE_KEY } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  addinvoicepayement,
  fetchclientbillinghistory,
  fetchClientalldetails,
  fetchtotalaccountusageofclient,
  addinvoicepayementfromOpenLink,
} from "AccountSettingsAction";
import { StripeProvider, Elements } from "react-stripe-elements";
import AddPayfastForm from "../../../../tickets/components/payout/payfast/add-payfast-form";
import renderHTML from "react-render-html";
import { converDateIntoLocalwithmonth, APP_API_KEY } from "Constants";
import LoginErrorBar from "../../../../../../starter/errorbar.js";

class PaymentinvoiceModal extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      btnLoading: false,
      showerror: false,
      alertMessage: "",
    };
  }
  closeModals = () => {
    this.props.reset();
    this.props.onClose();
  };

  renderList = (e) => {
    let { data } = this.props;
    let item = _.map(data.clientinvoiceitems_by_invoiceidfk, (data, index) => {
      var descriptionData = "";
      if (data.descriptiontext) {
        descriptionData = data.descriptiontext.replaceAll("\n", "<br/>");
      }
      return (
        <>
          <tr key={index} id={index}>
            <td className="td4">
              <div className="" style={{ fontWeight: 700 }}>
                {data.itemname}
              </div>
              <div className="">{renderHTML(descriptionData)}</div>
            </td>
            <td className="td3">
              {" "}
              <div className="ml-10"> {data.quantity} </div>
            </td>
            <td className="td3">
              {" "}
              <div className="ml-10"> {data.price} </div>
            </td>
            <td className="td3">
              {" "}
              <div className="ml-10"> ${data.total}</div>
            </td>
          </tr>
          {data.discountpercentage !== 0 && data.discountpercentage !== null ? (
            <tr key={index} id={index}>
              <td className="td4">
                <div className="" style={{ fontWeight: 700 }}>
                  {data.discounttext !== null ? data.discounttext : ""}
                </div>
              </td>
              <td className="td3">
                {" "}
                <div className="ml-10"> </div>
              </td>
              <td className="td3">
                {" "}
                <div className="ml-10">
                  {
                    LocaleStrings.accountsetting_billing_details_table_viewbillmodaldiscountedprice
                  }{" "}
                  ({data.discountpercentage}%)
                </div>
              </td>
              <td className="td3">
                {" "}
                <div className="ml-10">-${parseFloat(data.discountamount)}</div>
              </td>
            </tr>
          ) : (
            ""
          )}
        </>
      );
    });
    return item;
  };

  tokenReceived = (token, error) => {
    let { session, data, comeFrom } = this.props;
    this.props.showSuccess(LocaleStrings.accountsetting_billingdetails_payment);
    let paymentData = {
      type: "clientinvoicepayment",
      tokenid: token.id,
      clientid: data.clientid,
      invoiceid: data.id,
      cardid: token.card.id,
    };

    if (comeFrom == "billpayementoutside") {
      session.apiKey = APP_API_KEY;
      this.props.addinvoicepayementfromOpenLink(
        session,
        paymentData,
        (response) => {
          if (response.success == 0) {
            // this.closeModals();
            // this.props.showError(
            //   LocaleStrings.accountsetting_usagehistory_paymentfailed
            // );
            this.setState({
              alertMessage:
                LocaleStrings.accountsetting_usagehistory_paymentfailed,
              showerror: true,
            });
            setTimeout(() => {
              this.setState({ showerror: false });
              this.closeModals();
            }, 5000);
          } else {
            this.closeModals();
            this.props.history.push("/payementthanyoupage");
          }
        }
      );
    } else {
      this.props.addinvoicepayement(session, paymentData, (response) => {
        if (response.success == 0) {
          //   this.closeModals();
          this.props.showError(
            LocaleStrings.accountsetting_usagehistory_paymentfailed
          );
        } else {
          this.props.fetchclientbillinghistory(
            this.props.session,
            0,
            data.clientid,
            (CallBackResponse) => {
              this.props.fetchtotalaccountusageofclient(
                this.props.session,
                data.clientid
              );
              this.props.fetchClientalldetails(
                this.props.session,
                data.clientid
              );
              this.closeModals();
              // this.setState({loading: false});
              this.props.showSuccess(
                LocaleStrings.tickets_payfast_form_card_update_success
              );
            }
          );
        }
      });
    }
  };

  render() {
    let { clientdataforbilling, data } = this.props;

    let id = "";
    let items = [];
    let terms = "";
    let totalamount = 0;
    if (data) {
      id = data.id;
      items = data?.clientinvoiceitems_by_invoiceidfk;
      totalamount = data.total_amount;
      terms = data.terms;
    }

    let tabledate = "";
    let validupto = "";
    let usercredit = "";
    tabledate = converDateIntoLocalwithmonth(data.createdon).format(
      "D MMM YYYY"
    );
    // validupto = converDateIntoLocalwithmonth(
    //   data?.clients_by_clientid?.validupto
    // ).format("D MMM YYYY");

    if (data?.validitytill != "" && data?.validitytill != null) {
      validupto = converDateIntoLocalwithmonth(data?.validitytill).format(
        "D MMM YYYY"
      );
    }
    usercredit = data.userlimit ? data.userlimit : "";

    return (
      <Modal
        show={this.props.isOpen}
        onHide={this.closeModals}
        className=""
        dialogClassName="billing-payement-modal">
        {/* <Modal.Header >
                    <Modal.Title>
                        <div className="title-modal">{LocaleStrings.accountsetting_billing_details_addpayment}</div>
                    </Modal.Title>
                    <button
                        type="button"
                        className="i-custom-cross-popup pull-right"
                        onClick={this.closeModals}
                    >
                        <img
                            className="i-custom-small"
                            src="../../style/images/custom-icons/cross-black.png"
                        />
                    </button>
                </Modal.Header> */}
        <Modal.Body className="bg-white" style={{ borderRadius: "6px" }}>
          {this.state.showerror ? (
            <LoginErrorBar alertMessage={this.state.alertMessage} />
          ) : (
            ""
          )}
          <div className="row p-6">
            <div className="col-md-7 p-3 paymentdetails-box">
              <div className="text-center payementitemtexts">
                {_.startCase(data.type)}
              </div>
              <div className="d-flex">
                <div>
                  <div className="payementitemtexts">
                    {
                      LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_to
                    }
                  </div>
                  <div className="payementitemtexts">{data.clientname}</div>
                  <div className="payementitemtexts">{data.clientemail}</div>
                  <div className="payementitemtexts">{data.client_address}</div>
                  {data?.clients_by_clientid?.vat_number !== "" &&
                  data?.clients_by_clientid?.vat_number !== null ? (
                    <div className="payementitemtexts">
                      {LocaleStrings.accountsetting_billing_details_view_vat}{" "}
                      {data.clients_by_clientid.vat_number}
                    </div>
                  ) : (
                    ""
                  )}
                  {validupto != "" ? (
                    <div className="payementitemtexts">
                      {
                        LocaleStrings.accountsetting_billing_details_validitytill
                      }{" "}
                      {validupto}
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="payementitemtexts">
                    {LocaleStrings.accountsetting_billing_details_usercredit}{" "}
                    {usercredit}
                  </div>
                </div>
                <div className="text-end " style={{ marginLeft: "auto" }}>
                  <div className="payementitemtexts">
                    {_.startCase(data.type)} #{data.id}
                  </div>
                  <div className="payementitemtexts">
                    {
                      LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_preparedon
                    }{" "}
                    {tabledate}
                  </div>
                  <div className="payementitemtexts">
                    {
                      LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_preparedby
                    }{" "}
                    {
                      LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_silasname
                    }
                  </div>
                  <div className="payementitemtexts">
                    {
                      LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_silasemail
                    }
                  </div>
                </div>
              </div>
              {data && data.clientinvoiceitems_by_invoiceidfk.length > 0 ? (
                <>
                  <div className="mt-5">
                    <table className="table">
                      <thead>
                        <tr>
                          <th align="center">
                            {
                              LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th1
                            }
                          </th>
                          <th align="center">
                            {
                              LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th2
                            }
                          </th>
                          <th align="center">
                            {
                              LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th5
                            }
                          </th>
                          <th align="center">
                            {
                              LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th4
                            }
                          </th>
                        </tr>
                      </thead>
                      <tbody className="tbody-background">
                        {this.renderList()}
                      </tbody>
                    </table>
                  </div>
                  <div
                    className="payementitemtexts text-end"
                    style={{ marginLeft: "auto" }}>
                    <div className="" style={{ marginRight: "11%" }}>
                      {
                        LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_grandtotal
                      }{" "}
                      ${data.total_amount.toFixed(2)}
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {/* <div className="text-primary">
                                #Invoice {id}
                            </div>
                            {_.map(items, (val, index) => {
                                    return (
                                        <div className="d-flex mt-2">
                                        <div className="payementitemtexts"> {_.startCase(val.itemname)}</div>
                                        <div className="text-end payementitemtexts" style={{marginLeft:'auto'}}>${val.total}</div>
                                    </div>
                                    );
                                })}
                            <div className="d-flex mt-2">
                                <div className="" style={{fontWeight:'700'}}> Total</div>
                                <div className="text-end payementitemtexts" style={{marginLeft:'auto'}}>${totalamount}</div>
                            </div>
                            <div className="payementitemtexts mt-4">{terms}</div> */}
            </div>
            <div className="col-md-5 p-3 carddetails-box">
              <div className="mt-4 text-center" style={{ fontWeight: "700" }}>
                Payment
              </div>
              <div
                className="payementitemtexts text-center"
                style={{
                  fontSize: "12px",
                  marginTop: "5px",
                  marginBottom: "10px",
                  fontWeight: 700,
                }}>
                Please Enter Card Details.
              </div>
              <StripeProvider apiKey={STRIPE_PUBLISHABLE_KEY}>
                <Elements>
                  <AddPayfastForm
                    {...this.props}
                    onTokenReceived={this.tokenReceived}
                    onCloseModal={this.closeModals}
                    callFrom="accountsettings"
                    totalamount={totalamount}
                  />
                </Elements>
              </StripeProvider>
            </div>
          </div>
          {/* <StripeProvider apiKey={STRIPE_PUBLISHABLE_KEY}>
                <Elements>
                  <AddPayfastForm
                    {...this.props}
                    onTokenReceived={this.tokenReceived}
                    onCloseModal={this.closeModal}
                    callFrom="accountsettings"
                  />
                </Elements>
              </StripeProvider> */}
        </Modal.Body>
      </Modal>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
    clientdataforbilling: state.clientdataforbilling,
    client_historydata: state.client_historydata,
    data: ownProps.data,
  };
}
export default connect(mapStateToProps, {
  addinvoicepayement,
  fetchclientbillinghistory,
  fetchtotalaccountusageofclient,
  fetchClientalldetails,
  showError,
  showSuccess,
  addinvoicepayementfromOpenLink,
})(
  reduxForm({
    form: "PaymentinvoiceModalModalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(PaymentinvoiceModal)
);
